<template>
    <div class="input-group" style="width: 12em; max-width: 100%;">
      <field-icon :fieldData="fieldData"></field-icon>
      <money
      :ref="fieldData.field_name"
      :disabled="(!!showDisabled())"
      :aria-describedby="`${fieldData.field_name}_describedby`"
      v-model="fieldData.field_value"
      v-validate="field_rules"
      :maxlength="masked_num_maxlength(fieldData.max_length, field_rules)"
      :id="fieldData.field_name"
      :name="fieldData.field_name"
      @blur.native="apiRule.present && apiRule.type == 'onblur' ? postRule($event.target.value, fieldData) : ''"
       v-bind:class="{'form-control': true, 'error': errors.has(fieldData.field_name) || fieldData.has_error}">
      </money>
      <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
      <div>
        <input
        :disabled="(!!showDisabled())"
        v-show="false"
        :id="fieldData.field_name"
        :name="fieldData.field_name"
        type="text"
        class="form-control"
        :maxlength="fieldData.max_length"
        @blur="apiRule.present && apiRule.type == 'onblur' ? postRule($event.target.value, fieldData) : ''"
        @change="apiRule.present && apiRule.type == 'onchange' ? postRule($event.target.value, fieldData) : ''"
        v-model="fieldData.field_value"
        v-validate="field_rules"
        >
      </div>
    </div>
</template>

<script>
/* eslint prefer-const: */
/* eslint no-undef:  */
/* eslint no-cond-assign: */
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType', 'sendPostRule'],
  data() {
    return {
      field_rules: { required: false }, // Default rule for input validation
      phone_masked_input: '', // Holds the phone masked input value outside of the computed property to avoid an infinite loop
    };
  },
  components: { FieldIcon },
  mixins: [inputFieldMixin],
  methods: {
    // TODO: Abstract into helper class
    /**
     * The validation message overlaps the interactive form element, so it is cleared
     * once the components containing the element is clicked.
     */
    clearMessages() {
      this.fieldData.has_error = false; // Reset API errors to false upon any interaction
      this.errors.remove(this.fieldData.field_name); // Temporarily hide the validation message
    },
    /**
     * Sets the input element's `maxlength`.
     * Masked input elements add comma-delimited characters to numbers. This returns
     * the resulting `maxlength` by using either 1) the maximum valid numeric value,
     * or 2) the non-masked "maxlength" value.
     */
    masked_num_maxlength(originalMaxlength, fieldRules = null) {
      /* eslint radix:  */
      let numerator = parseInt(originalMaxlength);
      let divisor = 3; // Commas delimite once per 3 numeric characters
      let maxlength = numerator; // Start with the non-masked maxlength
      // If available, use the validation rules `max_value` instead
      if (fieldRules && fieldRules.max_value) {
        numerator = fieldRules.max_value;
        divisor = 1000; // Commas delimite once per division of 1,000
        maxlength = numerator.toString().length; // Start with the amount of numeric characters in the max value
      }

      while ((numerator = parseInt(numerator / divisor)) && numerator > 0) {
        maxlength += 1;
      }

      return maxlength;
    },
  },
  mounted() {
  //  this.phone_masked_input = this.fieldData.field_value; // Populate input value with its form data
  },
  // watch: {
  //   'fieldData.field_value': function fieldValue() {
  //     this.clearMessages();
  //   },
  // },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputMoney.vue?362e94aa